import React from 'react'
import TextBox from './fragments/TextBox'
import GreyBox from './fragments/GreyBox'
import ImageWithCaption from './fragments/ImageWithCaption'
import styles from './Interview.module.scss'
import { InterviewContentsProps, ContentData } from './fragments/type'
import SectionTitle from './fragments/SectionTitle'
import SubTitle from './fragments/SubTitle'
import ImageLink from './fragments/ImageLink'

const InterviewContents: React.FC<InterviewContentsProps> = ({ contentData }) => {
  const InterviewSection = ({ contents }: { contents: ContentData[] }) => {
    if (!Array.isArray(contents)) {
      return null
    }

    return (
      <>
        {contents.map((content, index) => {
          switch (content.type) {
            case 'textBox':
              return <TextBox key={index} texts={content.texts} wide={content.wide} bold={content.bold} />
            case 'greyBox':
              return (
                <GreyBox
                  key={index}
                  name={content.name}
                  namesub={content.namesub}
                  texts={content.texts}
                  color={content.color}
                />
              )
            case 'imageWithCaption':
              return (
                <ImageWithCaption
                  key={index}
                  src={content.src}
                  alt={content.alt}
                  text={content.text}
                  size={content.size}
                />
              )
            case 'sectionTitle':
              return <SectionTitle key={index} text={content.text} />
            case 'subTitle':
              return <SubTitle key={index} text={content.text} />
            case 'imageLink':
              return (
                <ImageLink key={index} src={content.src} srcsp={content.srcsp} alt={content.alt} link={content.link} />
              )
            default:
              return null
          }
        })}
      </>
    )
  }

  return (
    <>
      {Array.isArray(contentData)
        ? contentData.map((contents, index) => (
            <div className={styles.contents} key={index}>
              <InterviewSection contents={contents} />
            </div>
          ))
        : null}
    </>
  )
}

export default InterviewContents
